import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import {
  Article,
  EdsData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { ItemImageLocalCombination } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemImageLocalCombination/ItemImageLocalCombination";
import { ItemTotalQuantity } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemTotalQuantity/ItemTotalQuantity";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import styles from "../../../styles/common-media-styles.module.css";
import { ItemStockAndEds } from "../ItemStockAndEds/ItemStockAndEds";

interface MediaItemCardLocalCombinationInnerChildProps<
  T extends AggregatedArticle | Article,
> {
  article: T;
  shouldDisplayQuantity?: boolean;
  totalQuantityPieces?: number;
  edsData?: EdsData | null;
  itemCardRenderType?: ItemCardRenderType;
  stockInfo?: ItemStockInfo;
}

export const MediaItemCardLocalCombinationInnerChild = <
  T extends AggregatedArticle | Article,
>({
  article,
  shouldDisplayQuantity = false,
  totalQuantityPieces,
  edsData,
  itemCardRenderType,
  stockInfo,
}: MediaItemCardLocalCombinationInnerChildProps<T>) => {
  const itemNo = /^\d{8}$/.test(article.productArticleId)
    ? formatProductIdWithDots(article.productArticleId)
    : article.productArticleId;

  return (
    <>
      <ItemImageLocalCombination />
      <div className={styles["item-card-root-column"]}>
        <ItemName name={article.itemName} />
        {itemCardRenderType === ItemCardRenderType.static ? (
          <ItemNoWithCopy itemNo={itemNo} />
        ) : (
          <ItemNo itemNo={itemNo} />
        )}
        {shouldDisplayQuantity && totalQuantityPieces && (
          <ItemTotalQuantity totalPieces={totalQuantityPieces} />
        )}
        <ItemStockAndEds
          edsData={edsData}
          stockInfo={stockInfo}
          hfb={article.hfb}
        />
      </div>
    </>
  );
};
